

















import { Component, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import WidgetUser from '@/pantallas/SucursalVirtual/WidgetUser.vue';
import { MisSolicitudesHeaders } from './table_headers';
import MisSolicitudesTable from './table.vue';
import MisSolicitudesFilters from './filters.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { misSolicitudesService } from './MisSolicitudesService';
import { LoadingService } from '@/services/loadingService';
import {
  fetchMS,
  ConfigEmpresas,
} from '@/pantallas/SucursalVirtual/NuevaSolicitud/fetchConfigInicial';
import Analitica from '@/pantallas/SucursalVirtual/analitica_uso';

@Component({
  components: {
    WidgetUser,
    MisSolicitudesTable,
    MisSolicitudesFilters,
  },
})
export default class MisSolicitudes extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  readonly funcionalidad: Funcionalidades = Funcionalidades.MisSolicitudes;
  analytic = new Analitica(104, window.location.href);

  headers: any[] = MisSolicitudesHeaders;
  tableData: any[] = [];
  totalRegistros: number = 0;
  filters: any = {};
  empresas: ConfigEmpresas[] = [];

  readonly loadingService = new LoadingService();
  categoriaUsuario: string = null;

  constructor() {
    super();
  }

  async mounted() {
    let entrada = await this.analytic.entrada();
    this.getCategoriaUsuario();
    this.initialCharge();
    if (this.categoriaUsuario == 'Externo') {
      this.filters.IdCliente = JSON.parse(
        window.localStorage.user
      ).rutClienteDefecto || JSON.parse(window.localStorage.user).clienteDefecto;
    } else {
      this.getEmpresas();
    }
    //this.getSolicitudes();
  }

  async destroyed() {
    let salida = await this.analytic.salida(this.analytic.id_analitica);
  }

  grupoCuenta(e: any) {
    this.filters.LstCuentas = e;
  }

  initialCharge() {
    this.filters = {
      IdCliente: null,
      IdRazo: null,
      IdCategoria: '',
      fechadesde: '',
      fechahasta: '',
      LstCuentas: '',
      filtroTexto: '',
      OrderBy: 'caso.CreatedOn',
      Orden: 'DESC',
    };
  }

  filtroSolicitudes(filtros: any) {
    if (filtros.empresa.value == '') {
      this.$snotify.error('Debe seleccionar una empresa', { timeout: 3000 });
      return false;
    }
    if (filtros.estado.value == '') {
      this.$snotify.error('Debe seleccionar un estado', { timeout: 3000 });
      return false;
    }
  }

  async solicitudInicial() {}

  async getSolicitudes() {
    if (this.categoriaUsuario == 'Externo') {
      console.log('getSolicitudes categoriaUsuario='+this.categoriaUsuario)
      this.filters.IdCliente = JSON.parse(
        window.localStorage.user
      ).rutClienteDefecto || JSON.parse(window.localStorage.user).clienteDefecto;
    }
    var res: any = (await this.obtenerSolicitudes()) || [];
    if (res.CODIGO_RESPUESTA === '1') {
      this.tableData = res.data[0];
      this.totalRegistros = res.data[1];
    } else {
      this.$snotify.error(res.MENSAJE_RESPUESTA, { timeout: 3000 });
      this.tableData = [];
      this.totalRegistros = 0;
    }
  }
  obtenerSolicitudes() {
    this.loadingService.showLoading();
    return misSolicitudesService(this.filters)
      .catch(error => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener las solicitudes',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener las solicitudes',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  getFilter(e: any) {
    this.filters = e;
    this.getSolicitudes();
  }

  async getCategoriaUsuario() {
    let configOK = JSON.parse(window.localStorage.user).configOKSucursal;
    if (!configOK){
      this.$snotify.warning(
        'Usuario sin Sucursal Virtual activa en CRM',
        { timeout: 10000 }
      );
    }

    let categoria = JSON.parse(window.localStorage.user).categoria;
    if (categoria !== undefined) {
      console.log(
        'retorno categoria desde localStorage categoria=' +
          categoria +
          ' rut=' +
          JSON.parse(window.localStorage.user).rutClienteDefecto
      );
      this.categoriaUsuario = categoria;
      //this.filterField.IdCliente = JSON.parse(window.localStorage.user).rutClienteDefecto;
    } else {
      let r: any = [];
      r =
        (await this.fetchCategoriaUsuario(
          JSON.parse(window.localStorage.user).email
        )) || [];
      r = r['data'];
      if (r['CODIGO_RESPUESTA'] !== '1') {
        this.$snotify.error(r['MENSAJE_RESPUESTA'], { timeout: 3000 });
        this.categoriaUsuario = 'Externo';
      } else {
        categoria = r['categoria'];
        console.log(r);
        console.log('retorno categoria desde MS categoria=' + categoria);
        this.categoriaUsuario = categoria;
        if (this.categoriaUsuario == 'Interno') {
          this.getEmpresas();
        }
        if (!r['config_ok_sucursal']){
          this.$snotify.warning(
            'Usuario sin Sucursal Virtual activa en CRM',
            { timeout: 10000 }
          );
        }
      }
    }
  }
  fetchCategoriaUsuario(mail: string) {
    return fetchMS({ email: mail }, 'track/get_categoria_sc').catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categorias',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las categoriasp',
          { timeout: 3000 }
        );
      }
    });
  }

  async getEmpresas() {
    this.loadingService.showLoading(undefined, 'getEmpresas');
    let r: any = [];
    r = (await this.cargarEmpresas()) || [];
    r = r['data'];
    if (r['CODIGO_RESPUESTA'] == '1') {
      this.empresas = r['data'];
      this.filters.LstCuentas = this.empresas[0].idGrupoCuentas;
      this.$emit('lstCuenta', this.empresas[0].idGrupoCuentas);
      this.loadingService.hideLoading('getEmpresas');
    } else {
      this.$snotify.error(r['MENSAJE_RESPUESTA'], { timeout: 3000 });
      this.loadingService.hideLoading('getEmpresas');
    }

    //this.empresas = (await this.cargarEmpresas()) || [];
  }
  cargarEmpresas() {
    /*return fetchEmpresas().catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las empresas',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las empresas',
          { timeout: 3000 }
        );
      }
    });*/
    return fetchMS({}, 'track/get_ListadoCuentas_sc').catch(error => {
      if (error.message == 'Network Error') {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener el listado de cuentas',
          { timeout: 3000 }
        );
      } else if (error.response.status != 404) {
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener el listado de cuentas',
          { timeout: 3000 }
        );
      }
    });
  }

  exportarExcel(event: any) {
    if (typeof require !== 'undefined') {
      const XLSX = require('xlsx');

      let dataToExport = this.tableData.map(e => ({
        Título: e.titulo.replace(/(\r\n|\n|\r)/gm, ''),
        'Nº Solicitud': e.num_solicitud.replace(/(\r\n|\n|\r)/gm, ''),
        'Razón Social': e.razon_social.replace(/(\r\n|\n|\r)/gm, ''),
        Patente: e.patente.replace(/(\r\n|\n|\r)/gm, ''),
        Serie: e.serie.replace(/(\r\n|\n|\r)/gm, ''),
        RUT: e.rut.replace(/(\r\n|\n|\r)/gm, ''),
        Ejecutivo: e.ejecutivo.replace(/(\r\n|\n|\r)/gm, ''),
        Tipo: e.tipo.replace(/(\r\n|\n|\r)/gm, ''),
        'Fecha creación': e.fecha_creacion.replace(/(\r\n|\n|\r)/gm, ''),
        Descripción: e.descripcion.replace(/(\r\n|\n|\r)/gm, ''),
        Estado: e.estado.replace(/(\r\n|\n|\r)/gm, ''),
      }));

      let data = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      const filename = 'Documento';
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    }
  }

  @Watch('filters.LstCuentas')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.getSolicitudes();
  }
}
